import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";
import Payment from "payment";

import Icon from "./nounproject-ui-icon";
import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginBilling extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        if (!this.props.processing) {
            // Don't let users submit twice

            let expMonth, expYear;

            if (this.cardExpirationInput.value.includes("/")) {
                expMonth = this.cardExpirationInput.value.split("/")[0];
                expYear = this.cardExpirationInput.value.split("/")[1];
            } else {
                expMonth = this.cardExpirationInput.value.slice(0, 2);
                expYear = this.cardExpirationInput.value.slice(2, 4);
            }

            let formData = [
                { number: this.cardNumberInput.value },
                { cvc: this.cardCVCInput.value },
                { exp_month: expMonth },
                { exp_year: expYear },
                { name: this.cardNameInput.value }
            ];

            this.props.submit(formData);
        }
    }

    clearErrors() {
        this.setState({
            error: false,
            fieldErrors: {}
        });
    }

    closeAuthentication(e) {
        e.preventDefault();

        hashHistory.push("search");
    }

    componentDidMount() {
        Payment.formatCardNumber(document.querySelector("#card_number"));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            fieldErrors: {}
        };
    }

    render() {
        let cardNameInputClasses = ["input"],
            cardNumberLabel,
            cardNumberInputClasses = ["input"],
            cardExpirationLabel,
            cardExpirationInputClasses = ["input"],
            cardCvcLabel,
            cardCvcInputClasses = ["input"],
            submitButtonClasses = [
                "button",
                "blue",
                "full-width",
                "ui_arrow-right-line",
                "button-process"
            ],
            inputDisabled;

        if (this.props.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        if (this.state.fieldErrors.number) {
            cardNumberLabel = (
                <label
                    htmlFor="card_number"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.number}
                </label>
            );
            cardNumberInputClasses.push("error on");
        } else {
            cardNumberLabel = (
                <label
                    htmlFor="card_number"
                    data-label-text="Card Number"
                    className="show"
                >
                    Card Number
                </label>
            );
        }

        if (this.state.fieldErrors.card_expiration) {
            cardExpirationLabel = (
                <label
                    htmlFor="card_expiration"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.card_expiration}
                </label>
            );
            cardExpirationInputClasses.push("error on");
        } else {
            cardExpirationLabel = (
                <label
                    htmlFor="card_expiration"
                    data-label-text="Card Expiration"
                    className="on show"
                >
                    Card Expiration
                </label>
            );
        }

        if (this.state.fieldErrors.cvc) {
            cardCvcLabel = (
                <label
                    htmlFor="card_cvc"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.cvc}
                </label>
            );
            cardCvcInputClasses.push("error on");
        } else {
            cardCvcLabel = (
                <label
                    htmlFor="card_cvc"
                    data-label-text="CVC"
                    className="on show"
                >
                    CVC
                </label>
            );
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="loginView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        .loginView .text-link,
                        .loginView .text-link:hover {
                            color: white
                        }
                        .billing-form input{
                            padding: 20px 42px 20px 20px;
                        }
                    `}</style>
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeAuthentication.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <div
                        className="info-container"
                        style={{
                            display: "flex",
                            width: "100%",
                            minWidth: "250px",
                            maxWidth: "600px",
                            margin: "0 auto",
                            flexDirection: "column",
                            textAlign: "center"
                        }}
                    >
                        <i className="ui_pro-accounts plan-pro font-large" />
                        <h3 className="font-xlarge margin-m">NounPro</h3>
                        <div className="price-container">
                            <div className="price-sign-style">
                                <div className="price-dollar-sign">$</div>
                                <div className="price-dollars-bold">39</div>
                                <div className="price-cents-underline price-pro">
                                    99
                                </div>
                                <div className="price-stacked-type">
                                    billed yearly
                                </div>
                            </div>
                        </div>
                        <ul className="weight-light padding-b-l padding-t-l">
                            <li className="padding-s">
                                Unlock over a million icons
                            </li>
                        </ul>
                    </div>
                    <form
                        action={`/accounts/login/?next=/plugin/${this.props
                            .host}/#/search`}
                        method="POST"
                        className="new-form dark-form billing-form plugin-form"
                        onSubmit={this.attemptSubmitForm.bind(this)}
                        style={{
                            maxWidth: "600px",
                            margin: "0 auto"
                        }}
                    >
                        <ol>
                            <li className="padding-b-s">
                                <input
                                    className={cardNameInputClasses.join(" ")}
                                    type="text"
                                    name="card_name"
                                    id="card_name"
                                    placeholder="Name on card"
                                    required=""
                                    autoFocus="autofocus"
                                    ref={input => {
                                        this.cardNameInput = input;
                                    }}
                                    onFocus={this.clearErrors.bind(this)}
                                    disabled={inputDisabled}
                                />
                                <label
                                    htmlFor="card_name"
                                    data-label-text="Name on Card"
                                    className="on show"
                                >
                                    Name on Card
                                </label>
                            </li>
                            <li className="padding-b-s">
                                <input
                                    type="text"
                                    id="card_number"
                                    className={cardNumberInputClasses.join(" ")}
                                    placeholder="Credit Card Number"
                                    required=""
                                    ref={input => {
                                        this.cardNumberInput = input;
                                    }}
                                    onFocus={this.clearErrors.bind(this)}
                                    disabled={inputDisabled}
                                />
                                {cardNumberLabel}
                            </li>
                            <li className="padding-b-s">
                                <ul className="display-flex">
                                    <li
                                        className="margin-r-l"
                                        style={{ width: "100%" }}
                                    >
                                        <input
                                            type="text"
                                            name="card_expiration"
                                            id="card_expiration"
                                            className={cardExpirationInputClasses.join(
                                                " "
                                            )}
                                            placeholder="MM/YY"
                                            maxLength="5"
                                            required=""
                                            ref={input => {
                                                this.cardExpirationInput = input;
                                            }}
                                            onFocus={this.clearErrors.bind(
                                                this
                                            )}
                                            disabled={inputDisabled}
                                        />
                                        {cardExpirationLabel}
                                    </li>
                                    <li style={{ width: "100%" }}>
                                        <input
                                            type="text"
                                            id="card_cvc"
                                            placeholder="CVC"
                                            className={cardCvcInputClasses.join(
                                                " "
                                            )}
                                            maxLength="4"
                                            required=""
                                            ref={input => {
                                                this.cardCVCInput = input;
                                            }}
                                            onFocus={this.clearErrors.bind(
                                                this
                                            )}
                                            disabled={inputDisabled}
                                        />
                                        {cardCvcLabel}
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <button
                            className={submitButtonClasses.join(" ")}
                            type="submit"
                        >
                            <span>Charge card</span>
                        </button>
                    </form>
                    <div
                        className="display-flex"
                        style={{
                            justifyContent: "space-around",
                            padding: "8px",
                            maxWidth: "600px",
                            margin: "auto"
                        }}
                    >
                        <a
                            className="text-link plan-team dark"
                            href="/teams/"
                            title="Team Pricing"
                            target="_blank"
                            onClick={window.handleLink.bind(this)}
                        >
                            Team Pricing
                        </a>
                        <a
                            className="text-link plan-pro dark"
                            href="/for-edu/"
                            title="Education Pricing"
                            target="_blank"
                            onClick={window.handleLink.bind(this)}
                        >
                            Education Pricing
                        </a>
                    </div>
                </div>
                <PluginFooter />
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(PluginBilling);
